<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>销售计划使用说明:<br><br>
				  <span>1、提交后为锁定状态,如需修改请先作废。</span><br>
				  <span>2、查询关键字:开始日期、结束日期、业务员。</span><br>
				</h5>

			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
		</pre-base>
		

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "sellplan",
					"title": "销售计划",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_sell_car_plan',
					"upd_action": 'exp15_sell_car_plan',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "截止日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "销售人员",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_selluser",
							"sel_name": ""
						},
						{
							"name": "打款状态",
							"val": "",
							"key": "pay_flag",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_flag",
							"sel_name": ""
						}
					],
					"parm": [ 
						{
						  "name": "开始日期",
						  "val": "",
						  "key": "s_date",
						  "type": "date",
						  "class": "long1",
						  "p": "1",
						  "w": "0",
						  "r": "0",
						  "x": "1"
						},
						{
						  "name": "结束日期",
						  "val": "",
						  "key": "e_date",
						  "type": "date",
						  "class": "long1",
						  "p": "1",
						  "w": "0",
						  "r": "0",
						  "x": "1"
						},
						{
						  "name": "销售数量",
						  "val": "",
						  "key": "s_qty",
						  "type": "number",
						  "class": "long1",
						  "p": "1",
						  "w": "1",
						  "r": "0",
						  "x": "2"
						},
						{
						  "name": "销售金额",
						  "val": "",
						  "key": "s_amount",
						  "type": "number",
						  "class": "long1",
						  "p": "1",
						  "w": "1",
						  "r": "0",
						  "x": "2"
						},
						{
						  "name": "销售人员",
						  "val": "",
						  "key": "busi_name",
						  "type": "select",
						  "class": "long1",
						  "sel_action": "_base_selluser",
						  "sel_name": "",
						  "p": "1",
						  "w": "1",
						  "r": "0",
						  "x": "2"
						},
						{
						  "name": "备注",
						  "val": "",
						  "key": "note",
						  "type": "text",
						  "class": "long3",
						  "p": "1",
						  "w": "0",
						  "r": "0",
						  "x": "3"
						},
					],
					"parm_th": [
						{
						  "name": "序号"
						},
						{
						  "name": "开始日期"
						},
						{
						  "name": "结束日期"
						},
						{
						  "name": "销售数量"
						},
						{
						  "name": "销售金额"
						},
						{
						  "name": "业务员"
						},
						{
						  "name": "备注"
						},
						{
						  "name": "状态"
						},
						{
						  "name": "修改人"
						},
						// {
						//   "name": "浏览地址"
						// },
						// {
						//   "name": "存储地址"
						// },
						{
						  "name": "修改时间"
						}
					],
					"d_parm": [],
					"d_name": []

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode: function() {

				let sheet_no = '',flag='';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'sheet_no') {
						sheet_no = this.item[i].val;
					}
					if (this.item[i].key == 'flag') {
						flag = this.item[i].val;
					}
				}

				let o = {};
				o.title = '车牌';
				o.sheet_no = sheet_no;
				o.flag = flag;
				o.sel_action = 'exp_sell_car_file';
				o.upd_action = 'exp15_sell_car_file';
				o.file_action = 'sell_car_info';
				o.p1 = 'sellcar';
				o.p2 = sheet_no;

				o.list_action = '_base_sellfile';

				let that = this;
				this.$nextTick(function() {
					that.$refs['itemmode'].showpop(o);
				});


			},



		}
	};
</script>
<style>
</style>